import React from "react";
import { Zap, ShieldCheck, Globe2 } from "lucide-react";
import SharedHeroSection from "./SharedHeroSection";

export default function AboutHeroSection() {
    return (
        <SharedHeroSection
            badge="EST. 2016 · India & USA"
            title={(
                <>
                    <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
                        From Concept
                    </span> <br />to Reality in a Blink

                </>
            )}
            description="Enabling Startups and Enterprises Worldwide to build and launch their own products."
            descriptionClassName="mb-12"
        >
            <div className="flex flex-wrap justify-center gap-4">
                {[
                    { icon: Zap, label: "Fast Delivery", color: "text-amber-400", bg: "bg-amber-400/10", border: "border-amber-400/20" },
                    { icon: ShieldCheck, label: "Quality First", color: "text-emerald-400", bg: "bg-emerald-400/10", border: "border-emerald-400/20" },
                    { icon: Globe2, label: "Global Reach", color: "text-blue-400", bg: "bg-blue-400/10", border: "border-blue-400/20" },
                ].map((item, i) => (
                    <div key={i} className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border ${item.border} ${item.bg} backdrop-blur-sm`}>
                        <item.icon className={`w-5 h-5 ${item.color}`} />
                        <span className="text-sm font-medium text-white">{item.label}</span>
                    </div>
                ))}
            </div>
        </SharedHeroSection>
    );
}
